
const BASE_URL = "/services/plugin-extension-google"

export const getExtensionsQualifier = async () => {
    const response = await fetch(`${BASE_URL}/extension-service`);
    return response.json();
}

export const getApiWebKey = async (extensionQualifier: string) => {    
    if(!extensionQualifier) return 

    const response = await fetch(`${BASE_URL}/${extensionQualifier}/api-web-key`);
    
    return response.text();
}

export const reverseGeocoding =  async (qualifier: string, params: URLSearchParams): Promise<any[]> => {
    const result = await fetch(`${BASE_URL}/${qualifier}/reverse-geocode?${params.toString()}`)  
        
    return result.json().catch(error => ([]));
}
